"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var actions_1 = require("../actions/actions");
var transporter_1 = require("./transporter");
var create = function (_a) {
    var clientId = _a.clientId, _b = _a.log, log = _b === void 0 ? false : _b;
    var isReadyMutable = false;
    var _c = (0, transporter_1.registerIframe)(log), dispatch = _c.dispatch, suscribe = _c.suscribe;
    var onReady = function (callback) {
        if (isReadyMutable) {
            throw new Error("onReady should be run only once");
        }
        var readyUnsuscribe = suscribe(actions_1.ACTION_CONNECTED, function () {
            callback();
            readyUnsuscribe();
            isReadyMutable = true;
        });
        dispatch({ type: actions_1.ACTION_CONNECTED });
    };
    return {
        clientId: clientId,
        dispatch: dispatch,
        suscribe: suscribe,
        onReady: onReady,
    };
};
exports.create = create;
